import { useState } from "react";
import { toast } from "sonner";
import { MessageSquarePlus } from "lucide-react";
import { api, apiError } from "../../lib/api";

export const FeedbackLink = ({ sessionId, questionNumber }) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await api.post("/feedback", { exam_session_id: sessionId, question_number: questionNumber, note: note.trim() });
      setSent(true);
      setOpen(false);
      toast.success("Feedback sent to the content team — thank you. We review everything but can't reply individually.");
    } catch (e) {
      toast.error(apiError(e, "Could not send feedback"));
      if ([409, 429].includes(e.response?.status)) { setSent(true); setOpen(false); }
    } finally {
      setBusy(false);
    }
  };

  if (sent) return <span className="text-xs text-slate-400">Feedback sent — thank you</span>;
  if (!open)
    return (
      <button data-testid={`feedback-link-${questionNumber}`} onClick={() => setOpen(true)}
        className="flex items-center gap-1 text-xs text-slate-400 hover:text-slate-600 transition-colors">
        <MessageSquarePlus className="w-3.5 h-3.5" /> Feedback on this question
      </button>
    );
  return (
    <div className="mt-1 flex items-start gap-2">
      <textarea
        data-testid={`feedback-note-${questionNumber}`}
        value={note}
        maxLength={250}
        rows={2}
        autoFocus
        onChange={(e) => setNote(e.target.value)}
        placeholder="What's wrong or unclear? (max 250 characters)"
        className="flex-1 text-sm border border-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
      />
      <button data-testid={`feedback-send-${questionNumber}`} onClick={send} disabled={busy || note.trim().length < 3}
        className="text-xs font-medium px-3 py-2 rounded-lg bg-blue-700 hover:bg-blue-800 text-white disabled:opacity-50 transition-colors">
        Send
      </button>
      <button onClick={() => { setOpen(false); setNote(""); }} className="text-xs text-slate-400 hover:text-slate-600 px-2 py-2">
        Cancel
      </button>
    </div>
  );
};
